if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.#init();
    }

    #init() {

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const convertedThreshold = Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const freeShippingRemaining = cartTotal - convertedThreshold;
      let shippingMessage = '';
      let shippingSuccess = false

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this.#formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));

      } else {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
        shippingSuccess = true;
      }

      /* Assaggia: prominent progress bar towards the free shipping threshold.
         Width = cart total / threshold, capped at 100%. Blue gradient fill,
         green when unlocked, with a "$X of $Y" progress label. */
      const shippingProgress = convertedThreshold > 0 ? Math.min(cartTotal / convertedThreshold, 1) * 100 : 100;
      const progressLabel = `${this.#formatMoney(Math.min(cartTotal, convertedThreshold), KROWN.settings.shop_money_format)} of ${this.#formatMoney(convertedThreshold, KROWN.settings.shop_money_format)}`;
      const barFill = shippingSuccess
        ? 'linear-gradient(90deg, #2E7D32, #4CAF50)'
        : 'linear-gradient(90deg, #1E3F81, #3F6AD8)';
      const shippingProgressBar = `
        <div class="free-shipping-progress" style="margin-top:10px;">
          <div style="height:12px;background:rgba(30,63,129,0.15);border-radius:6px;overflow:hidden;box-shadow:inset 0 1px 2px rgba(0,0,0,0.08);" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(shippingProgress)}">
            <div style="height:100%;width:${shippingProgress}%;background:${barFill};border-radius:6px;transition:width .5s ease;"></div>
          </div>
          <div style="margin-top:6px;font-size:0.85em;font-weight:700;letter-spacing:.02em;display:flex;justify-content:space-between;">
            <span>${shippingSuccess ? '🎉' : '🚚'}</span>
            <span>${progressLabel}</span>
          </div>
        </div>`;

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            <div style="font-weight:700;">${shippingMessage}</div>
            ${shippingProgressBar}
          </div>`;
      } else {
        this.innerHTML = `<div style="font-weight:700;">${shippingMessage}</div>${shippingProgressBar}`;
      }

    }
    
    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}